import { slugify } from "utils"

const updateProductPlacementDetails = ({ product, shopifyProduct }) => {
  const {
    review,
    title,
    price,
    url,
    image,
    subtitle,
    testimonial,
    testimonialAttribution,
    testimonialVideoId,
    relatedArticle,
  } = shopifyProduct

  if (!product.title) {
    product.title = title
  }

  if (!product.buttonText) {
    product.buttonText = url?.match(/\/products\//) ? "Shop now" : "Learn more"
  }

  if (!product.image) {
    if (image) {
      product.image = { path: image, crops: [] }
    }
  }

  if (product.image && !product.image.altText) {
    product.image.altText = product.title || title
  }

  if (!product.url) {
    if (url) product.url = url
  }

  if (price) {
    product.price = price
  }

  if (!product.description) {
    if (subtitle) {
      product.description = subtitle
    }
  }

  // use the title from the Shopify product to create the trackProduct
  product.trackProduct = slugify(title)

  if (review) {
    const { productScore, totalReviews } = review
    if (productScore && productScore >= 3.5) {
      product.rating = productScore
      product.ratingP = product.rating / 5.0
      product.ratingP *= 100
      product.totalReviews = totalReviews
    }
  }

  product.testimonial = testimonial?.html
  product.testimonialAttribution = testimonialAttribution?.html
  product.testimonialVideoId = testimonialVideoId
  product.relatedArticle = relatedArticle

  return product
}

const updateReviewItemProductDetails = ({ product, shopifyProduct }) => {
  const { title, price, url, image, subtitle } = shopifyProduct

  if (!product.title) {
    product.title = title
  }

  if (!product.description) {
    product.description = subtitle
  }

  if (!product.company) {
    product.company = "mindbodygreen"
  }

  if (!product.image) {
    if (image) {
      product.image = { path: image, crops: [] }
    }
  }

  if (!product.sources) {
    product.sources = [
      {
        source: "mindbodygreen",
        price,
        url,
      },
    ]
  }

  return product
}

const updateShopComponentDetails = ({ product, shopifyProduct }) => {
  const { url, subtitle, image, title, price, variantId } = shopifyProduct

  if (!product.productName) {
    product.productName = title
  }

  if (!product.buttonText) {
    product.buttonText = "Shop Now"
  }

  if (!product.image) {
    if (image) {
      product.image = { path: image, crops: [] }
    }
  }

  if (product.image && !product.image.altText) {
    product.image.altText = product.title || title
  }

  if (!product.url) {
    if (url) {
      product.url = url
    }
  }

  if (variantId) {
    product.variantId = variantId
  }

  if (!product.price) {
    product.price = price
  }

  if (!product.description) {
    product.description = subtitle
  }

  return product
}

const swapShopifyProduct = ({ item, type, shopifyProducts }) => {
  const { productId } = item
  if (!productId) {
    return item
  }

  const shopifyProduct = shopifyProducts.find(
    (p) => Number(p.legacyResourceId) === Number(productId),
  )
  if (!shopifyProduct) {
    return item
  }

  if (type === "product") {
    return updateProductPlacementDetails({ product: item, shopifyProduct })
  }

  if (type === "review") {
    return updateReviewItemProductDetails({ product: item, shopifyProduct })
  }

  if (type === "shop") {
    return updateShopComponentDetails({ product: item, shopifyProduct })
  }

  return item
}

export default swapShopifyProduct
